<!-- Subtabla Expediciones -->
<table>
    <thead>
        <tr>
            <th class="id sortable" (click)="toOrderBy('x=> x.certificadoExpedicionId', 'id')">
                ID
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('id')"></i>
                </div>
            </th>
            <th class="date sortable" (click)="toOrderBy('x=> x.CertificadoExpedicion.FechaExpedicion', 'fechaExpedicion')">
                {{ 'global.fecha.expedicion' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('fechaExpedicion')"></i>
                </div>
            </th>
            <th class="string">{{ 'global.matricula' | translate }}</th>
            <th class="string sortable" (click)="toOrderBy('x=> x.CertificadoExpedicion.NCertificadoExpedicion', 'numeroCertificado')">
                {{ 'global.certificadoNum' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('numeroCertificado')"></i>
                </div>
            </th>
            <th class="number sortable" (click)="toOrderBy('x=> x.Unidades', 'unidades')">
                {{ 'global.unidades' | translate }}
                <div class="sortable-icons">
                    <i [ngClass]="getIcon('unidades')"></i>
                </div>
            </th>
            <th class="actions"></th>
        </tr>
    </thead>
    <tbody *ngFor="let expedicion of expediciones; let i = index; trackBy: trackByCertificadoExpedicionId">
        <tr>
            <td class="id">{{ expedicion.certificadoExpedicionId }}</td>
            <td class="date">{{ expedicion.fechaExpedicion | date: 'shortDate' : undefined : defaultLanguage }}</td>
            <td class="string">{{ expedicion.matricula }}</td>
            <td class="string">{{ expedicion.nCertificadoExpedicion }}</td>
            <td class="number">{{ expedicion.unidades | number : '1.0-0': defaultLanguage }}</td>
            <td class="actions"></td>
        </tr>
    </tbody>
    <tfoot *ngIf="(!expediciones || (expediciones && expediciones.length < 1))">
        <tr>
            <td colspan="6">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>

<app-paginator
    *ngIf="expediciones && expediciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
    [totalItems]="totalItems" [visiblePages]="visiblePages" 
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>